module.exports = __webpack_public_path__ + "img/websitetheme-upgrade.e0478f28.svg";